import { ArrowDown, ArrowUpRight } from 'lucide-react';
import HeroSculpture from './HeroSculpture';
import { profile } from '../profileData';

function FieldSculpture() {
  return <svg viewBox="0 0 600 600" className="foundation-fallback" aria-hidden="true">
    <ellipse cx="300" cy="460" rx="205" ry="50" fill="#185b40" />
    <ellipse cx="300" cy="440" rx="205" ry="50" fill="#a4cf99" />
    <path d="M300 440 Q300 300 140 240 M300 440 V180 M300 440 Q300 300 460 240" fill="none" stroke="#78ab88" strokeWidth="10" />
    <path d="M95 175 L140 190 L185 175 V250 L140 265 L95 250 Z" fill="#b1d5a3" stroke="#246c48" strokeWidth="4" />
    <path d="M265 130 L300 110 L335 130 V175 L300 195 L265 175 Z" fill="#2c7c54" />
    <circle cx="460" cy="212" r="40" fill="#28784e" /><ellipse cx="460" cy="212" rx="60" ry="22" fill="none" stroke="#8ebf8d" strokeWidth="6" />
  </svg>;
}
export default function Hero({ motionEnabled }) {
  return <section className="hero-v2 story-hero" aria-labelledby="hero-title">
    <div className="hero-v2-top"><span><i className="status-dot" /> MASAHIKO SAKAI / PORTFOLIO</span><span>ROOTED IN REALITY. OPEN TO POSSIBILITY.</span></div>
    <div className="hero-v2-grid">
      <div className="hero-v2-copy">
        <p className="hero-v2-name">{profile.name}<span>ENGINEER & EXPLORER</span></p>
        <h1 id="hero-title">Beyond<br /><span>boundaries</span></h1>
        <p className="hero-v2-lead">現場で聞く、つくる<br />使えるまで、確かめる</p>
        <p className="hero-v2-description">教室でのつまずきも、研究室選びの迷いも、<br className="desktop-copy-break" />地域の見回りの負担も。<br />当事者の声を聞き、自分の足で確かめ、技術で形にする。<br />領域が広がっても、出発点はいつも現場です。</p>
        <div className="hero-v2-actions"><a className="button button-green" href="#approach">取り組みを見る <ArrowUpRight size={18} /></a><a href="#about">プロフィール <ArrowUpRight size={17} /></a></div>
        <p className="hero-v2-academic">会津大学大学院 <span>{profile.graduation}</span></p>
      </div>
      <HeroSculpture enabled={motionEnabled} fallback={<FieldSculpture />} />
    </div>
    <div className="hero-v2-bottom"><span>ONE APPROACH. <b>↗</b> MANY POSSIBILITIES.</span><a href="#approach">SCROLL TO DISCOVER <ArrowDown size={16} /></a></div>
  </section>;
}
